import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { StatusBadge } from "@/pages/Dashboard";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

function CustomerTable({ rows, onOpen, kind, empty }) {
  return (
    <div className="overflow-hidden rounded-xl border border-border bg-white">
      <Table>
        <TableHeader><TableRow>
          <TableHead className="overline">Name</TableHead>
          <TableHead className="overline">Email</TableHead>
          <TableHead className="overline">{kind === "web" ? "Verified" : "Phone"}</TableHead>
          <TableHead className="overline">Orders</TableHead>
          <TableHead className="overline">Total Spent</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">{empty}</TableCell></TableRow>}
          {rows.map((c) => (
            <TableRow key={c.id} className="cursor-pointer hover:bg-slate-50" onClick={() => onOpen(c)} data-testid={`${kind === "web" ? "member" : "customer"}-row-${c.id}`}>
              <TableCell className="font-medium">{c.name || "—"}</TableCell>
              <TableCell className="text-muted-foreground">{c.email || "—"}</TableCell>
              <TableCell className="text-muted-foreground">{kind === "web" ? (c.email_verified ? "Yes" : "Pending") : (c.phone || "—")}</TableCell>
              <TableCell>{c.order_count}</TableCell>
              <TableCell className="font-semibold">{money(c.total_spent)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

export default function Customers() {
  const [list, setList] = useState([]);
  const [members, setMembers] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => {
    api.get("/admin/customers").then((r) => setList(r.data));
    api.get("/admin/members").then((r) => setMembers(r.data));
  }, []);
  const open = async (c) => setSel((await api.get(`/admin/customers/${c.id}`)).data);
  const openMember = async (m) => {
    const d = (await api.get(`/admin/members/${m.id}`)).data;
    setSel({ ...d, phone: d.delivery?.phone, address: d.delivery?.address });
  };

  return (
    <div data-testid="customers-page">
      <h1 className="font-head text-3xl font-extrabold tracking-tight">Customers</h1>
      <p className="mt-1 text-sm text-muted-foreground">{list.length} Telegram customers · {members.length} website members</p>

      <Tabs defaultValue="telegram" className="mt-6">
        <TabsList>
          <TabsTrigger value="telegram" data-testid="customers-tab-telegram">Telegram ({list.length})</TabsTrigger>
          <TabsTrigger value="web" data-testid="customers-tab-web">Website members ({members.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="telegram" className="mt-4"><CustomerTable rows={list} onOpen={open} kind="tg" empty="No customers yet." /></TabsContent>
        <TabsContent value="web" className="mt-4"><CustomerTable rows={members} onOpen={openMember} kind="web" empty="No website members yet." /></TabsContent>
      </Tabs>

      <Dialog open={!!sel} onOpenChange={(v) => !v && setSel(null)}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="customer-dialog">
          {sel && (
            <>
              <DialogHeader><DialogTitle>{sel.name || "Customer"}</DialogTitle></DialogHeader>
              <div className="text-sm space-y-1">
                <div className="text-muted-foreground">{sel.email}</div>
                <div className="text-muted-foreground">{sel.phone}</div>
                <div className="text-muted-foreground">{sel.address}</div>
                {sel.telegram_username && <div className="text-muted-foreground">@{sel.telegram_username}</div>}
              </div>
              <div className="overline text-muted-foreground mt-2">Order History</div>
              <div className="space-y-2">
                {sel.orders.map((o) => (
                  <div key={o.id} className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-sm">
                    <span className="font-semibold">{o.order_number}</span>
                    <div className="flex items-center gap-3"><StatusBadge status={o.status} /><span className="font-medium">{money(o.total)}</span></div>
                  </div>
                ))}
                {sel.orders.length === 0 && <p className="text-sm text-muted-foreground">No orders.</p>}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
